import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import { store } from "../..";
import "../../assets/css/wibb/pages/tournaments.scss";
import { tournamentManagementActions } from "../../features/tourneymgmt/tournamentManagementSlice";
import { useAppSelector } from "../../hooks/reduxHooks";
import { TOURNAMENT_LOGO_URL } from "../../lib/globals";
import { defaultDateFormat } from "../../lib/utils";
import { IMasterTournament } from "../../types/api";

export const loader = async () => {
    const tournaments = store.getState().tournamentmanagement.tournaments;
    const masterTournaments =
        store.getState().tournamentmanagement.masterTournaments;

    const tournamentsPromise = tournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getTournaments());

    const masterTournamentsPromise = masterTournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getMasterTournaments());

    await Promise.all([tournamentsPromise, masterTournamentsPromise]);

    return {
        header: "Standings / Schedules",
    };
};

const TournamentsIndex = (): React.JSX.Element => {
    const { tournaments, masterTournaments } = useAppSelector(
        state => state.tournamentmanagement,
    );

    const buildReturn = (tournamentList: IMasterTournament[]) => {
        return tournamentList
            .filter(t => t.settings?.showToPublic)
            .map(t => (
                <div className="tournament" key={t.id}>
                    <h4>
                        {defaultDateFormat.format(new Date(t.startDate))} -{" "}
                        {defaultDateFormat.format(new Date(t.endDate))}
                    </h4>
                    <div className="tournamentDetails">
                        <div className="tournamentLogo">
                            {t.logo && (
                                <img
                                    src={`${TOURNAMENT_LOGO_URL}${t.logo}`}
                                    alt={`${t.name} logo`}
                                    className="tournamentLogo"
                                />
                            )}
                        </div>

                        <div className="tournamentInfo">
                            <ul>
                                <li>
                                    <h3>{t.name}</h3>
                                </li>
                                <li className="ageLevels">
                                    {tournaments
                                        .filter(ct => ct.parent === t.id)
                                        .map(ct => (
                                            <span
                                                className="h3"
                                                key={`${t.id}-${ct.id}`}
                                            >
                                                <Link to={`${ct.id}`}>
                                                    {ct.ageLevel}
                                                </Link>
                                            </span>
                                        ))}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            ));
    };
    const upcoming = masterTournaments.filter(
        t => new Date() < new Date(t.startDate),
    );
    const current = masterTournaments.filter(
        t =>
            new Date(t.startDate) <= new Date() &&
            new Date() <= new Date(t.endDate),
    );
    const previous = masterTournaments.filter(
        t => new Date() > new Date(t.endDate),
    );

    return (
        <Container className="tournaments" data-testid="tournamentsContent">
            <Row id="tournamentList" className="mt-0">
                <h3>Currently Active Tournaments</h3>
                <Col>
                    {current.length ? (
                        buildReturn(current)
                    ) : (
                        <h4>No Currently Active Tournaments</h4>
                    )}
                </Col>

                <h3 className="mt-5">Upcoming Tournaments</h3>
                <Col>
                    {upcoming.length ? (
                        buildReturn(upcoming)
                    ) : (
                        <h4>No Upcoming Tournaments</h4>
                    )}
                </Col>

                <h3 className="mt-5">Previous Tournaments</h3>
                <Col>
                    {previous.length ? (
                        buildReturn(previous)
                    ) : (
                        <h4>No Previous Tournaments This Year</h4>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default TournamentsIndex;
